import api from "./index";

export const solveChecklistStepService = async (
  eventChecklistId,
  userChecklistId,
  solved
) =>
  await api.put("/event-user-checklist", {
    eventChecklistId,
    userChecklistId,
    solved,
  });

export const getChecklistService = async (eventId, status, sortBy, sortOrder) =>
  await api.get(`/event-user-checklist/filtered`, {
    params: {
      eventId,
      status,
      sortBy,
      sortOrder,
    },
  });
